@if (languageChange$ | async; as _lang) {
<ng-container *transloco="let t">
  <!-- begin:: Header -->
  <div class="offcanvas-header p-5 border border-bottom-2">
    <h4 class="offcanvas-title" transloco="label_quick_access"></h4>
    <button type="button" class="btn-close btn btn-light-secondary rounded" aria-label="Close"
      (click)="activeOffcanvas.dismiss()"></button>
  </div>
  <!-- end:: Header -->
  <!-- begin:: Body -->
  <div class="offcanvas-body p-2 responsive-scroll">
    <!--begin::Menu-->
    <div
      class="menu menu-rounded menu-column menu-lg-row menu-root-here-bg-desktop menu-active-bg menu-state-primary menu-title-gray-800 menu-arrow-gray-400 align-items-stretch flex-grow-1 my-2 my-lg-0 px-2 px-lg-0 fw-semibold fs-6">
      <!-- BEGIN:: SECTION 1 -->
      <!--begin::Heading-->
      <div class="menu-item">
        <div class="menu-content pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bold" transloco="label_menus"></span>
        </div>
      </div>
      <!--end::Heading-->
      <!--begin::Home-->
      <div class="menu-item">
        <a [title]="t('label_home')" [routerLink]="['/',_lang]" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" class="menu-link py-3" transloco="label_home">
        </a>
      </div>
      <!--end::Home-->
      <!--begin::Affiliated companies-->
      <div class="menu-item">
        <a [title]="t('label_affiliated_companies')" [routerLink]="['/',_lang,'affiliated-companies']"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-link py-3"
          transloco="label_affiliated_companies">
        </a>
      </div>
      <!--end::Affiliated companies-->
      <!--begin::Saved Parts-->
      <div class="menu-item">
        <a [title]="t('label_saved_parts')" [routerLink]="['/',_lang,'saved-parts']" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" class="menu-link py-3">
          <span transloco="label_saved_parts"></span>
          @if (totalSavedParts>0) {
          <span class="badge badge-circle badge-primary badge-sm ms-2">
            {{totalSavedParts}}
          </span>
          }
        </a>
      </div>
      <!--end::Saved Parts-->
      <!-- END:: SECTION 1 -->
      <!-- BEGIN:: SECTION 2 -->
      <!--begin::Heading-->
      <div class="menu-item pt-5">
        <div class="menu-content pb-2">
          <span class="menu-section text-muted text-uppercase fs-7 fw-bold"
            transloco="sentence_what_are_you_looking_for"></span>
        </div>
      </div>
      <!--end::Heading-->
      <!--begin::Car Parts-->
      @if (flags.carParts) {
      <div class="menu-item">
        <a [title]="t('label_car_parts')"
          [routerLink]="['/',_lang,'pb',t('label_search')|makemepretty,t('label_type')|makemepretty]"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-link py-3"
          transloco="label_car_parts">
        </a>
      </div>
      }
      <!--end::Car Parts-->
      <!--begin::Truck Parts-->
      @if (flags.truckParts) {
      <div class="menu-item">
        <a [title]="t('label_truck_parts')"
          [routerLink]="['/',_lang,'ov',t('label_search')|makemepretty,t('label_type')|makemepretty,t('label_other')|makemepretty]"
          [queryParams]="{vc2: '107'}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link py-3" transloco="label_truck_parts">
        </a>
      </div>
      }
      <!--end::Truck Parts-->
      <!--begin::Motorcycle and Scooter-->
      @if (flags.mcScooter) {
      <div class="menu-item">
        <a [title]="t('label_motorcycle_and_scooter_parts')"
          [routerLink]="['/',_lang,'ov',t('label_search')|makemepretty,t('label_type')|makemepretty,t('label_other')|makemepretty]"
          [queryParams]="{vc2: '105'}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link py-3" transloco="label_motorcycle_and_scooter_parts">
        </a>
      </div>
      }
      <!--end::Motorcycle and Scooter-->
      <!--begin::Caravan-->
      @if (flags.caravan) {
      <div class="menu-item">
        <a [title]="t('label_motorhome_and_caravan')"
          [routerLink]="['/',_lang,'ov',t('label_search')|makemepretty,t('label_type')|makemepretty,t('label_other')|makemepretty]"
          [queryParams]="{vc2: '104'}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link py-3" transloco="label_motorhome_and_caravan">
        </a>
      </div>
      }
      <!--end::Caravan-->
      <!--begin::Snowmobile-->
      @if (flags.snowmobile) {
      <div class="menu-item">
        <a [title]="t('label_snowmobile')"
          [routerLink]="['/',_lang,'ov',t('label_search')|makemepretty,t('label_type')|makemepretty,t('label_other')|makemepretty]"
          [queryParams]="{vc2: '106'}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="menu-link py-3" transloco="label_snowmobile">
        </a>
      </div>
      }
      <!--end::Snowmobile-->
      <!--begin::Other-->
      @if (flags.other) {
      <div class="menu-item">
        <a [title]="t('label_other')"
          [routerLink]="['/',_lang,'pb',t('label_search')|makemepretty,t('label_type')|makemepretty,'s1',t('label_other')|makemepretty]"
          routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="menu-link py-3"
          transloco="label_other">
        </a>
      </div>
      }
      <!--end::Other-->
      <!-- END:: SECTION 1 -->

      <!-- BEGIN:: SECTION 2 -->
      <!--begin:: Choose brand and model link -->
      <div class="menu-item">
        <a [title]="t('sentence_choose_brand_and_model')"
          [routerLink]="['/',_lang,'pb',t('label_search')|makemepretty,t('label_type')|makemepretty]"
          class="menu-link py-3" transloco="sentence_choose_brand_and_model">
        </a>
      </div>
      <!--end:: Choose brand and model link -->
      <!--begin:: Search part without choosing brand link -->
      <div class="menu-item">
        <a [title]="t('sentence_search_part_without_choosing_brand')"
          [routerLink]="['/',_lang,'pb',t('label_search')|makemepretty,t('label_type')|makemepretty,'s9','AP']"
          class="menu-link py-3" transloco="sentence_search_part_without_choosing_brand">
        </a>
      </div>
      <!--end:: Search part without choosing brand link -->
      <!--begin:: Dismantled vehicles link -->
      <div class="menu-item">
        <a [title]="t('label_dismantled_vehicle')"
          [routerLink]="['/',_lang,'vs',t('label_search')|makemepretty,t('label_dismantled_vehicle')|makemepretty]"
          class="menu-link py-3" transloco="label_dismantled_vehicle">
        </a>
      </div>
      <!--end:: Dismantled vehicles link -->
      <!-- END:: SECTION 2 -->

    </div>
    <!--end::Menu-->
  </div>
  <!-- begin:: Body -->
</ng-container>
}